/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdjustTransactionAmountRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {AdjustTransactionAmountResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const adjustTransactionAmount = (request: AdjustTransactionAmountRequest, options?: CashRequestOptions) => post<AdjustTransactionAmountRequest, AdjustTransactionAmountResponse>("/2.0/cash/adjust-transaction-amount", request, {...options, rejectOnError: true })